import useTranslation from 'next-translate/useTranslation';
import { styled } from '@nx-kit/styling';
import { Heading } from 'components/atoms/Heading';
import Button from 'components/atoms/Button/Button';
import getHeadingSkin from 'helpers/getHeadingSkin';
import getHeadingTag from 'helpers/getHeadingTag';
import { MediaTrackConstraints, QrScanModalProps } from './QrScanModal.types';
import { useState } from 'react';
import dynamic from 'next/dynamic';

const QrReader = dynamic(() => import('react-qr-reader'), { ssr: false });

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  height: calc(100vh - 70px);
  left: 0;
  top: 70px;
  background: ${(props) => props.theme.global.color.white};
  z-index: ${({ theme }) => theme.global.zIndex.guideQrScanModal};
`;

const HeadingStyled = styled(Heading)`
  width: auto;
  height: 40px;
  margin: 40px 30px;
  max-width: 327px;
  text-align: center;
`;

const ButtonCloseStyled = styled(Button)`
  margin-bottom: 70px;
`;

export const QrScanModal: React.FC<QrScanModalProps> = ({ className, onCloseCallback }) => {
  const { t } = useTranslation('common');
  const [startScan, setStartScan] = useState<boolean>(true);

  function onSwitchScan() {
    setStartScan((prevState) => !prevState);
  }

  // @ts-ignore
  let handleScan = (data) => {
    if (data) {
      setStartScan(false);
      window.location.href = data;
    }
  };
  // @ts-ignore
  const handleError = (err) => {
    console.error(err);
  };

  return (
    <Wrapper className={className}>
      <HeadingStyled skin={getHeadingSkin('heading2')} elementType={getHeadingTag('heading2')}>
        {t('modalQrCodeHeadline')}
      </HeadingStyled>
      <Button onPress={onSwitchScan} skin="primary">
        {startScan ? t('qrScanCTAStop') : t('qrScanCTAStart')}
      </Button>

      {startScan && (
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '300px', height: '400px', display: 'block' }}
          facingMode={MediaTrackConstraints.environment}
        />
      )}

      <ButtonCloseStyled
        onPress={() => {
          setStartScan(false);
          onCloseCallback();
        }}
        skin="minimal"
      >
        {t('modalQrCodeClose')}
      </ButtonCloseStyled>
    </Wrapper>
  );
};
